/* eslint-disable @typescript-eslint/no-explicit-any */
import { Autocomplete, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { FileServicesBack } from '../../services/api/files/FileServicesBack';

type VAutoCompletFilesProps = {
  initValue?: string[];
  onChange: (event: React.SyntheticEvent, newValue: string[]) => void;
};

export const VAutoCompletFiles = ({
  initValue = [],
  onChange,
}: VAutoCompletFilesProps) => {
  const [data, setData] = useState<string[]>([]);

  const processData = (arr: any): string[] => {
    if (!Array.isArray(arr)) {
      return [];
    }

    return arr.map((item) => {
      if (typeof item === 'string') {
        return item;
      } else if (typeof item === 'object' && item !== null) {
        return item.name || item.title || item.label || String(item);
      }
      return String(item);
    });
  };

  useEffect(() => {
    getFilesType();
  }, []);

  async function getFilesType() {
    try {
      const value = await FileServicesBack.getFileType();
      if (value instanceof Error) {
        console.log(value.message);
        setData([]);
      } else {
        const processedData = processData(value);
        setData(processedData);
      }
    } catch (error) {
      setData([]);
    }
  }

  const handleSelectChange = (
    event: React.SyntheticEvent,
    newValue: string | null
  ) => {
    onChange(event, newValue ? [newValue] : []);
  };

  return (
    <Autocomplete
      options={data}
      getOptionLabel={(option) => String(option)}
      value={
        Array.isArray(initValue) && initValue.length > 0 ? initValue[0] : null
      }
      id="id_tipo"
      onChange={handleSelectChange}
      renderInput={(params) => (
        <TextField {...params} label="Tipo de Arquivo" />
      )}
    />
  );
};
